//
//  App.tsx
//
//  isana.net,inc. Proprietary and Confidential
//
import { MOCK_USED } from "./utils/env";
import { mock } from "./mock/mock";
import { AppRoutes } from "./routes";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Typography } from "@mui/material";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from "./contexts/AuthContext";

// フォントを指定
const theme = createTheme({
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      '"Hiragino Sans"', 
      '"Hiragino Kaku Gothic ProN"',
      '"Noto Sans JP"',
      'Meiryo', 
      'sans-serif',
    ].join(','),
  },
});

const App: React.FunctionComponent = () => {
  if (MOCK_USED) {
    mock();
  }
  const environment = process.env.REACT_APP_APP_ENV;
  const firebaseId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /> 
      <>
        {environment == "dev" && (
          // NOTE: 作業ミスを防ぐために開発環境で作業していることを明示している
          <Typography
            variant="h3"
            color={"#E00"}
            fontWeight={"bold"}
            sx={{
              p: 1,
              background: "#EE0",
              animation: "blink 1s infinite",  //アニメーションを適用
              "@keyframes blink": {
                // blinkアニメーションを定義
                "0%": { opacity: 1 },
                "50%": { opacity: 0 },
                "100%": { opacity: 1 },
              },
            }}
          >
            {`${firebaseId}開発`}
          </Typography>
        )}
        <AuthProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <AppRoutes />
          </LocalizationProvider>
        </AuthProvider>
      </>
    </ThemeProvider>
  );
};

export default App;